<template>
  <v-navigation-drawer
    v-model="visible"
    @input="onInput"
    :color="$vuetify.breakpoint.mdAndUp ? 'transparent' : 'white'"
    :permanent="$vuetify.breakpoint.mdAndUp"
    :temporary="$vuetify.breakpoint.smAndDown"
    :width="$vuetify.breakpoint.mdAndUp ? 280 : 360"
    app
    overflow
    fixed
    floating
    clipped
    touchless
  >
    <div class="text-center px-3">
      <v-btn
        v-if="$vuetify.breakpoint.smAndDown"
        @click="visible = !visible"
        color="error"
        class="elevation-0 mt-2 text right"
        block
        outlined
      >
        <v-icon>mdi-chevron-double-left</v-icon>
        <span> ปิด </span>
      </v-btn>
    </div>

    <div>
      <user-info-card v-if="showEmp && hasEmpInfoData" :info="empInfo" />

      <navigation-menu :list="list" />
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    showEmp: {
      type: Boolean,
      default: true
    },
    empInfo: {
      type: Object,
      default: () => {}
    },
    list: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    hasEmpInfoData() {
      if (this.empInfo && this.empInfo.constructor === Object) {
        return Object.keys(this.empInfo).length > 0
      } else {
        return false
      }
    }
  },

  methods: {
    onInput(e) {
      this.$emit('onToggleNav', e)
    }
  }
}
</script>
